import type {
    ScopedUserViewContextContribution,
    UserViewContextContributionAction,
} from '../types';

const reduceUserViewContextContribution = (
    currentContribution: ScopedUserViewContextContribution | null,
    action: UserViewContextContributionAction
): ScopedUserViewContextContribution | null => {
    if (action.type === 'publish') {
        return action.payload;
    }

    if (currentContribution?.sourceId === action.payload.sourceId) {
        return null;
    }

    return currentContribution;
};

export default reduceUserViewContextContribution;
